import React from 'react';
import PropTypes from 'prop-types';
import AppContainerStyles from './AppContainer.less';
import getBackground from 'nucleus-widgets/utils/style/getBackground';
import ThemeImagesContext from 'nucleus-widgets/context/ThemeImagesContext';

/**
 * A container that should be present in the root of your guest side application
 * that applies global level theme settings to the page (backgrounds, widths, etc).
 * The children of this component should be your website content.
 */
export default class AppContainer extends React.Component {
  static displayName = 'AppContainer';
  static propTypes = {
    theme: PropTypes.object.isRequired,
    imageLookup: PropTypes.object,
    browserFeatures: PropTypes.shape({
      supportsWebp: PropTypes.bool
    }),
    children: PropTypes.node
  };

  render() {
    const { theme, children, imageLookup, browserFeatures: { supportsWebp } = {} } = this.props;
    return (
      <ThemeImagesContext.Consumer>
        {(themeImages) => {
          const backgroundStyles = {
            ...getBackground(theme.global, {}, theme.global.palette, themeImages, imageLookup, supportsWebp),
            borderRadius: 0
          };
          // Fixed position backgrounds require a different DOM structure.
          if (backgroundStyles.fixedPosition) {
            return (
              <div className={AppContainerStyles.wrapper}>
                <div className={`${AppContainerStyles.container} ${AppContainerStyles.fixedBackground}`}
                  style={backgroundStyles} />
                <div style={{ maxWidth: theme.global.dimensions.maxWidth, margin: 'auto' }}>
                  {children}
                </div>
              </div>
            );
          }
          return (
            <div className={AppContainerStyles.container} style={backgroundStyles}>
              <div style={{ maxWidth: theme.global.dimensions.maxWidth, margin: 'auto' }}>
                {children}
              </div>
            </div>
          );
        }}
      </ThemeImagesContext.Consumer>
    );
  }
}
